
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // baseApi: "http://123.56.47.201:48080",
    // baseApi: "http://39.99.255.10:9040",
    baseApi: "http://dzsc.mdyzc.cn",
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
